import { CommissionType } from '../domain/types';

export const commissionTypeLabels: Record<CommissionType, string> = {
  COMMISSION: 'Standard',
  OVER: 'Over',
  REFERRAL: 'Referral',
};
